import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Bell, X, Check } from 'lucide-react';

export default function NotificationBanner() {
  const [notification, setNotification] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const checkNotifications = async () => {
      try {
        const res = await api.get('/notifications/');
        if (!res.data.length) return;
        const latest = res.data[0];
        const lastSeen = localStorage.getItem('orcfacil_last_notification');
        if (lastSeen !== latest.id) {
          setNotification(latest);
          setVisible(true);
        }
      } catch {}
    };
    const timer = setTimeout(checkNotifications, 1500);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    if (notification) localStorage.setItem('orcfacil_last_notification', notification.id);
    setVisible(false);
  };

  if (!visible || !notification) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60">
      <div className="bg-zinc-900 border border-orange-500/40 rounded-2xl p-6 max-w-sm w-full shadow-2xl animate-fade-in">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 bg-orange-500/20 rounded-xl flex items-center justify-center shrink-0">
            <Bell size={20} className="text-orange-400" />
          </div>
          <div className="flex-1">
            <h3 className="font-heading font-bold text-white">{notification.titulo}</h3>
            <div className="text-xs text-zinc-500 mt-0.5">Novidade no OrcFácil</div>
          </div>
          <button onClick={dismiss} className="text-zinc-500 hover:text-white transition-colors">
            <X size={18} />
          </button>
        </div>
        <p className="text-sm text-zinc-300 leading-relaxed">{notification.texto}</p>
        <button
          data-testid="dismiss-notification-btn"
          onClick={dismiss}
          className="mt-4 w-full flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-400 text-white font-semibold py-2.5 rounded-xl transition-colors text-sm"
        >
          <Check size={15} />
          Entendido
        </button>
      </div>
    </div>
  );
}
